export enum SafeType {
    HTML = 'html',
    STYLE = 'style',
    SCRIPT = 'script',
    URL = 'url',
    RESOURCE = 'resourceUrl'
}
